module.exports = __webpack_public_path__ + "img/check.971804e1.png";